// src/components/Footer.jsx
import React from "react";
import { BRAND } from "../config/brandConfig";

function Footer() {
  return (
    <footer
      style={{
        borderTop: "1px solid rgba(15,23,42,0.08)",
        backgroundColor: "#ffffff",
        marginTop: "2rem",
      }}
    >
      <div
        style={{
          maxWidth: "1120px",
          margin: "0 auto",
          padding: "1.25rem 1.5rem",
          fontSize: 12,
          color: "#64748b",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "0.75rem",
        }}
      >
        <div>
          © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
        </div>
        <div style={{ display: "flex", gap: "1rem" }}>
          <span>New England • Boston • Providence • Portsmouth</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
